<template>
<div class="language-content">
<!-- v-if:false
<h2>{{ lang_header }}</h2>
-->
<div v-for="(rowItem, rowIndex) in layoutList(layout_content)" :key="rowIndex" :class="getRowClass(rowIndex)">

    <div v-for="(itemValue, colIndex) in rowItem" :key="colIndex" :class="getColumnClass(rowIndex, colIndex)">
        <div v-if="itemValue == '&nbsp;'">&nbsp;</div>
        <button v-else-if="itemValue" :value="itemValue" @click="addToSearchInput(itemValue)" :class="getButtonClass()">{{ itemValue }}</button>
        <div v-else=""><br /></div>
    </div>
</div>
</div>
</template>

<script>
export default {
    props: ['itemValue', 'lang_header', 'lang_layout', 'layout_content'],

    mounted() {
        this.layoutList();
    },

    methods: {
        getLayout() {
            let layout = {
                default: [],
                shift: []
            };

            return layout;
        },

        getRowClass(rowIndex) {
            return 'row mx-0 index-' + rowIndex;
        },

        getColumnClass(rowIndex, colIndex) {
            return 'char-block';
        },

        getButtonClass() {
            return 'btn custom-btn margin';
        },

        layoutList(layoutContent) {
            let layoutList = [];
            let layout = [];

            if (!layoutContent)
                layout = this.getLayout();
            else
                layout = layoutContent;

            for (let i in layout.default) {
                let contentList = layout.default[i].split(' ');
                layoutList[i] = contentList;
            }

            return layoutList;
        },

        addToSearchInput(buttonValue) {
            let searchEl = document.getElementById('search');
            if (searchEl) {
                let searchValue = searchEl.value;
                searchValue += buttonValue.toString();
                this.$emit('add-to-search', searchValue);
                searchEl.value = searchValue;
                searchEl.focus();
            }
        }
    }
}
</script>
